
import React, { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ExamCreationVideo from "../../assets/Videos/SamparkSoftwares_exam_creation.mp4";
import QnAVideo from "../../assets/Videos/Sampark_QnA.mp4";
import ExamVideo from "../../assets/Videos/Sampark_exam.mp4";


const CustomCarousel = () => {
  return (
    <Carousel autoPlay showIndicators={false} infiniteLoop showThumbs={false}>
      <div>
        <iframe width="560" height="380" src={"https://chatbot.samparkme.com/static/media/Sampark_QnA.be8896173bb3c1331159.mp4"} title="QNA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <p className="Image text-white font-bold">Once a document is uploaded, after successful vectorization, at which point users can start Q&A interactions with the uploaded document.</p>
      </div>
      <div>
        <iframe width="560" height="380" src={"https://chatbot.samparkme.com/static/media/SamparkSoftwares_exam_creation.f92e37534a36e2e6d7fc.mp4"} title="Exam Creation" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <p className="Image text-white font-bold">Here you can upload document for generate question and answers.After successful question creation you can create exam paper.</p>
      </div>
      <div>
        <iframe width="560" height="380" src={"https://chatbot.samparkme.com/static/media/Sampark_exam.030d4cb4b6f31a30483f.mp4"} title="Exam" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <p className="Image text-white font-bold">Once exam created.anyone can attempt exam by using exam section.</p>
      </div>
    </Carousel>
  )
}

export default CustomCarousel;

